import React from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';

import { CaretDownOutlined } from '@ant-design/icons';
import { changeLanguage } from 'states/common/actions';
import useActions from 'hooks/useActions';
import { selectLanguage } from 'states/common/selectors';

// import USLang from 'assets/images/icons/us-lang.svg';
// import VNLang from 'assets/images/icons/vn-lang.svg';
import './style.scss';
import { setMomentLocale } from 'utilities/time';

const { Option } = Select;

const Language = (props) => {
  const [changeLanguageAction] = useActions([changeLanguage]);
  const defaultLang = useSelector(selectLanguage());
  const handleChange = (value) => {
    localStorage.setItem('language', value);
    setMomentLocale(value);
    changeLanguageAction(value);
  };

  return (
    <Select
      {...props}
      defaultValue={defaultLang}
      className="lang-wrapper"
      suffixIcon={<CaretDownOutlined />}
      onChange={handleChange}
    >
      <Option key="en" value="en">
        <div className="lang-item ">
          {/* <img src={USLang} alt="us-lang" /> English */}
        </div>
      </Option>
      <Option key="vi" value="vi">
        <div className="lang-item ">
          {/* <img src={VNLang} alt="us-lang" /> Vietnam */}
        </div>
      </Option>
    </Select>
  );
};

export default Language;
